import React from 'react';
import { Neo, Routing } from '@singularsystems/neo-react';
import { Audit, Catalogue } from '@singularsystems/neo-react-services';
import { observer } from 'mobx-react';
import { catalogueRoutes } from "./CatalogueRoutes";
import { AppService, DomainTypes } from '../../DomainTypes';
import AuthorisationVM from '../../Services/AuthorisationVM';
import AuthorisationComponents from '../../Components/AuthorisationComponents';
import CatalogueAuthorisation from './CatalogueAuthorisation';

@observer
export default class CatalogueView extends Catalogue.CatalogueViewBase {

    constructor(props: unknown) {
        super(
            "Catalogue",
            props,
            catalogueRoutes);

        CatalogueAuthorisation.authorisationVM = this.viewModel.registerViewModel(AuthorisationVM);
    }

    public static getRouteChildren() {
        return this.getViewRoutes(catalogueRoutes);
    }

    protected auditApiClient(): Audit.IAuditApiClient | null {
        return AppService.get(DomainTypes.ApiClients.Audit);
    }

    public render() {
        return <>
            {super.render()}
            <AuthorisationComponents viewModel={CatalogueAuthorisation.authorisationVM} />
        </>
    }

    protected renderMenu() {
        return (
            <Neo.GridLayout lg={3} arrangeVertically>

                {this.tryRenderSection(catalogueRoutes.classification, children =>
                    <Neo.Card title="Classification">{children}</Neo.Card>)}

                {this.tryRenderSection(catalogueRoutes.investment, children =>
                    <Neo.Card title="Investments">{children}</Neo.Card>)}

                {this.tryRenderSection(catalogueRoutes.reporting, children =>
                    <Neo.Card title="Reporting">{children}</Neo.Card>)}

                {this.tryRenderSection(catalogueRoutes.general, children =>
                    <Neo.Card title="General">{children}</Neo.Card>)}

                {this.tryRenderSection(catalogueRoutes.pipeline, children =>
                    <Neo.Card title="Pipeline">{children}</Neo.Card>)}

            </Neo.GridLayout>
        )
    }

    beforeRouteChanged(props: Routing.IRouteChangedProps): void {
        if (this.viewModel.editInstance?.isDirty) {
            props.leavePrompt = "Are you sure you want to leave this page without saving?"
        }
    }
}